import { createTheme } from "@mui/material/styles"

import { PRIMARY } from "./colors"

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
      main: PRIMARY
    },
    secondary: {
      main: "#E8E8E8"
    },
    warning: {
      main: "#EFD28A"
    },
    text: {
      primary: "#000000"
    }
  },
  spacing: 8,
  shape: {
    borderRadius: 4
  },
  typography: {
    button: {
      textTransform: "none",
      fontWeight: "bold",
      boxShadow: "none",
      borderRadius: 1.6
    },
    fontFamily: [
      "Helvetica Neue",
      "Roboto",
      "-apple-system",
      "BlinkMacSystemFont"
    ].join(",")
  }
})

export default theme
